import ProjectsPage from "./projects-page";

export default ProjectsPage;